import { IMkRegionPopupProps } from '../../components/search/RegionPopup/MkRegionPopup'
import { mapChildren } from './helpers'

export function configToRegionPopupProps(node: any): IMkRegionPopupProps {
  if (!node || !node.children) {
    return {
      boxTitle: '',
      featuredRegionsHeading: '',
      moreRegionHeading: '',
      recentSearchesHeading: '',
      clearHistoryLabel: '',
      mapIcon: '',
      recentSearchIcon: '',
      noResultsLabel: '',
      noResultsText: '',
      regions: [],
      handleRegionClick: () => {},
      handleLocationSearch: () => {},
    }
  }

  return {
    boxTitle: mapChildren('boxTitle', node) || 'Where is your next adventure?',
    featuredRegionsHeading: mapChildren('featuredRegionsHeading', node) || 'Search by Region',
    moreRegionHeading: mapChildren('moreRegionHeading', node) || 'More Regions',
    recentSearchesHeading: mapChildren('recentSearchesHeading', node) || 'Recent Searches',
    clearHistoryLabel: mapChildren('clearHistoryLabel', node) || 'Clear History',
    mapIcon: mapChildren('mapIcon', node) || 'map-location-dot',
    recentSearchIcon: mapChildren('recentSearchIcon', node) || 'clock-rotate-left',
    noResultsLabel: mapChildren('noResultsLabel', node) || 'No matching results',
    noResultsText:
      mapChildren('noResultsText', node) ||
      'No results were found for the location you entered. Please double-check your spelling, try a different location, or select a region below.',
    regions: [],
    handleRegionClick: () => {},
    handleLocationSearch: () => {},
  }
}
